import { FileMetadata } from "@domain/schemas/BI";
import type { IAuthenticatedRequestHandlerService } from "@application/contracts/services";
import { API_ENDPOINTS } from "@infrastructure/InfrastructureConstants";
import { runtimeConfig } from "@utils/runtimeConfig/runtimeConfig";
import { TYPES } from "@utils/inversifyJS/types";
import axios, { CancelToken } from "axios";
import { inject, injectable } from "inversify";

@injectable()
export class LibraryRepository {
    private readonly baseUrl = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.libraries}`;
    private readonly uploadUrl = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.librariesUpload}`;

    @inject(TYPES.IAuthenticatedRequestHandlerService)
    private _requestHandlerService!: IAuthenticatedRequestHandlerService;

    public async getLibraries(): Promise<FileMetadata[]> {
        return this._requestHandlerService.handleRequestAsync<FileMetadata[]>(() => axios.get<FileMetadata[]>(this.baseUrl));
    }

    public async uploadLibrary(
        file: File,
        folder: string,
        onProgress?: (progress: number) => void,
        cancelToken?: CancelToken
    ): Promise<void> {
        const url = `${this.uploadUrl}?folder=${folder}`;
        const formData = new FormData();
        formData.append("file", file);

        await this._requestHandlerService.handleRequestAsync<void>(() =>
            axios.post<void>(url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                timeout: 24 * 60 * 60 * 1000,
                cancelToken,
                onUploadProgress: (progressEvent) => {
                    if (onProgress) {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
                        onProgress(percentCompleted);
                    }
                },
            })
        );
    }
}
